import * as _ from "lodash";
import {Component, NgZone, OnInit} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Shipment} from "../services/shipment";
import {ShipmentsService} from "../services/shipments.service";
import {MapboxGeoJSONFeature, Marker} from "mapbox-gl";
import {ShipmentRoute} from "../services/shipment-route";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {ShipmentEvent} from "../services/shipment-event";
import {Lightbox} from "ngx-lightbox";
import {DomSanitizer} from "@angular/platform-browser";
import {Observable, Subscription} from "rxjs";

declare let NProgress: any;

@Component({
    selector: 'app-shipment-edit-modal',
    templateUrl: './shipment-edit-modal.component.html',
    styleUrls: ['./shipment-edit-modal.component.scss'],
    providers: [ShipmentRoutesService]
})

export class ShipmentEditModalComponent implements OnInit {
    album;

    modal: NgbModalRef;

    showAddress: boolean = false;
    showDriver: boolean = false;
    showEvents: boolean = false;
    simple: boolean = false;

    shipment: Shipment;
    _shipment: Shipment;

    shipmentRoutes: ShipmentRoute[];

    checking = false;
    saving = false;

    saved;


    imageLoaded;
    points: GeoJSON.FeatureCollection<GeoJSON.Point>;
    selectedPoint: MapboxGeoJSONFeature | null;
    cursorStyle: string;

    private shipmentsUpdatedObservable: Observable<boolean>;
    private shipmentsUpdatedSubscribtion: Subscription;

    constructor(public shipmentsService: ShipmentsService,
                public shipmentRoutesService: ShipmentRoutesService,
                public lightbox: Lightbox,
                private sanitized: DomSanitizer
    ) {
        this.shipmentsUpdatedObservable = this.shipmentsService.getShipmentsUpdatedStream();

    }

    ngOnInit() {
        this.refreshData();
        this.shipmentsUpdatedSubscribtion = this.shipmentsUpdatedObservable.subscribe((event) => {
            if (event === true) {
                this.refreshData();
            }
        });
    }


    refreshData() {
        this.shipmentsService.getShipment(this.shipment.id, {combineEvents: true}).then((response) => {
            this._shipment = response;
                        if (this.showDriver) {
                this.shipmentRoutesService.getShipmentRoutes().then(shipmentRoutes => {
                    this.shipmentRoutes = shipmentRoutes.filter(route => route.branch === this._shipment.branch);
                });
            }
        });
    }

    updateChanges() {
        this.refreshData();
    }

    save() {
        this.saving = true;
        this.shipmentsService.updateShipment(this._shipment).then(response => {
            this.saving = false;
            this.close();
            this.saved(response);
        });
    }


    close() {
        this.modal.close();
    }


    openImageLink(image_link: any) {
        this.album = [
            {
                src: image_link.preview_url,
                caption: image_link.title,
                thumb: image_link.preview_url
            }
        ];

        this.lightbox.open(this.album, 0);
    }

    open(shipmentEvent: ShipmentEvent) {
        let image = this.sanitized.bypassSecurityTrustResourceUrl('data:image/jpeg;base64, ' + shipmentEvent.image);

        this.album = [
            {
                src: image,
                caption: shipmentEvent.status_text,
                thumb: image
            }
        ];

        this.lightbox.open(this.album, 0);
    }
}
